import { actionGenerator } from '../../utils/actionGenerator';
import { EActionTypes } from './types';
var SET_ESTIMATION_TARGET = EActionTypes.SET_ESTIMATION_TARGET,
    SET_USER_AREA_FLAG = EActionTypes.SET_USER_AREA_FLAG,
    SET_ERROR = EActionTypes.SET_ERROR,
    SET_ROOMS = EActionTypes.SET_ROOMS,
    SET_JK_ROOMS = EActionTypes.SET_JK_ROOMS,
    SET_AREA = EActionTypes.SET_AREA,
    SET_ADDRESS = EActionTypes.SET_ADDRESS,
    SET_NEWBUILDING_ID = EActionTypes.SET_NEWBUILDING_ID,
    SET_HOUSE_ID = EActionTypes.SET_HOUSE_ID,
    RESET_FILTERS = EActionTypes.RESET_FILTERS;
export var setAddress = actionGenerator(SET_ADDRESS);
export var setRooms = actionGenerator(SET_ROOMS);
export var setJkRooms = actionGenerator(SET_JK_ROOMS);
export var setUserAreaFlag = actionGenerator(SET_USER_AREA_FLAG);
export var setArea = actionGenerator(SET_AREA);
export var setError = actionGenerator(SET_ERROR);
export var resetFilters = actionGenerator(RESET_FILTERS);
export var setEstimationTarget = actionGenerator(SET_ESTIMATION_TARGET);
export var setNewbuildingId = actionGenerator(SET_NEWBUILDING_ID);
export var setHouseId = actionGenerator(SET_HOUSE_ID);